import React from 'react'

const TickSml = () => (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.94536 0.225104L3.02703 6.27949L1.42692 4.46178C0.728176 3.86053 -0.375834 4.56664 0.127259 5.4755L2.02783 8.69845C2.32829 9.10394 3.02703 9.50943 3.73276 8.69845C4.03322 8.29995 9.74193 1.13396 9.74193 1.13396C10.4477 0.329972 9.54628 -0.37614 8.94536 0.225104Z" fill="black"/>
    </svg>
)

export default TickSml